import React, { Component } from 'react'
import PropTypes from 'prop-types'

export class Dropdown extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: false,
      selected: '選択して下さい'
    }
  }
  shouldComponentUpdate (nextProps, nextState) {
    if (
      this.state.isOpen !== nextState.isOpen ||
      this.state.selected !== nextState.selected
    ) {
      return true
    } else {
      return false
    }
  }

  _renderDropdownList () {
    return (
      <ul className={ this.state.isOpen ? 'opened' : 'closed' }>
        {
          this.props.choices.map(choice => {
            if (
              choice.id !== 'created_date' &&
              choice.id !== 'registered_users' &&
              choice.id !== 'room_count' &&
              choice.id !== 'csv_url' &&
              choice.id !== 'chat' &&
              choice.id !== 'registered_users' &&
              choice.id !== 'push'
            ) {
              return <li key={choice.name} data-id={choice.id} data-search={choice.name} onClick={this._handleDropdownClick.bind(this)}>{choice.name}</li>
            }
            return null
          })
        }
      </ul>
    )
  }

  _toggleDropdown () {
    this.setState({ isOpen: !this.state.isOpen })
  }

  _handleDropdownClick (e) {
    const newTerm = e.currentTarget.dataset.search
    const newTermID = e.currentTarget.dataset.id
    this.setState({ selected: newTerm })
    this.props.updateTerm(newTermID)
    this._toggleDropdown()
  }

  render () {
    return (
      <div
        className={ `${this.state.isOpen ? 'opened' : 'closed'} dropdown_container`}
        style={this.state.isOpen ? {maxHeight: (this.props.choices.length * 42) + 56} : null}
      >
        <div className="selected flex align-center" onClick={this._toggleDropdown.bind(this)}>
          <span className="selected_text">{this.state.selected}</span>
          <span className="arrow">▼</span>
        </div>
        { this._renderDropdownList() }
      </div>
    )
  }
}

Dropdown.propTypes = {
  updateTerm: PropTypes.func,
  choices: PropTypes.array
}

Dropdown.defaultProps = {
  choices: []
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/_common/Dropdown.js